export enum L1CategoryIds {
    FOR_SALE = 2549,
    JOBS = 2553,
    MOTORS = 2551,
    FLATS_AND_HOUSES = 10201,
    SERVICES = 2554,
    COMMUNITY = 2550,
    PETS = 2526,
}

export enum L2CategoryIds {
    CARS = 9311,
    CARS_WANTED = 10301,
    CARS_PARTS = 9314,
    CARS_ACCESSORIES = 10016,
    FREEBIES = 120,
    HOME_GARDEN = 2514,
    HOUSE_CLEARANCE = 153,
    IPHONE = 10205,
    MOTORBIKES = 10442,
    JOBS_WANTED = 2541,
    OTHER_VEHICLES = 11983,
    PETS_EQUIPMENT_AND_ACCESSORIES = 1018,
    PETS_FOR_SALE = 9395,
    PETS_MISSING_LOST_AND_FOUND = 1976,
    PROPERTY_TO_RENT = 12181,
    PROPERTY_TO_SHARE = 12183,
    PROPERTY_FOR_SALE = 12182,
    PROPERTY_INTERNATIONAL = 12177,
    PROPERTY_WANTED = 12175,
    HOME_SWAP = 1040,
    TICKETS = 2521,
    OFFICE_FURNITURE = 4626,
    OTHER_GOODS = 2524,
    STUFF_WANTED = 2525,
    SWAP_SHOP = 1039,
    VANS = 94,
    DIY_TOOLS_MATERIALS = 10683,
}

export enum L3CategoryIds {
    AQUARIUM = 4710,
    FISH = 9393,
    CATS = 9390,
    DOGS = 9389,
    PHONES = 4660,
}

export enum LeafCategoryIdsWithPhones {
    APPLE_IPHONE = 10205,
    BLACKBERRY = 4656,
    HTC = 10206,
    LG = 4657,
    MOTOROLA = 4658,
    NOKIA = 63,
    O2_XDA = 10207,
    ORANGE = 10208,
    OTHER = 10210,
    SAMSUNG = 4663,
    SIEMENS = 4665,
    SONY_ERICSSON = 4666,
    TMOBILE_MDA = 4667,
    Google = 12308,
    XIAOMI = 12309,
    HUAWEI = 12310,
    HONOR = 12311,
    ONEPLUS = 12312,
    OPPO = 12313,
}
